import Field from '@base/Form/Field';
import { useEffect, useState } from 'react';
import {
  Error,
  FieldWrapperSmall,
  FormSectionSubHeading,
  SubFormContainer,
  FieldWrapper,
  StyledDropdown,
  StyledTextField
} from './styles';
import {
  isImageSizeValid,
  isImageTypeValid,
  isRequired,
  isNumericOnlyError,
  isIdLengthValidError
} from './utils';
import { candidateIdTypes } from '../constants';

import FileUploader from './FileUploader';

const renderErrorMessage = ({ message }) => {
  return <Error>{message}</Error>;
};

const UploadPhotos = ({ registrar, updateStoreData }) => {
  const candidateIdTypeValue = registrar.data.candidateIdType?.value;
  const [candidateIdType, setCandidateIdType] = useState(candidateIdTypeValue);

  useEffect(() => {
    setCandidateIdType(candidateIdTypeValue);
  }, [candidateIdTypeValue]);

  return (
    <SubFormContainer>
      <FormSectionSubHeading>Upload learner’s photo</FormSectionSubHeading>
      <FieldWrapperSmall>
        <Field
          registrar={registrar}
          name="candidatePhoto"
          rules={[
            isRequired('Upload the image'),
            isImageTypeValid('Upload an image in .png or .jpg format'),
            isImageSizeValid('Image size should not exceed 10 MB')
          ]}
          render={({ onChange, value, hasError }) => (
            <FileUploader
              value={value}
              error={hasError}
              onOptionClick={(data) => {
                onChange(data);
                updateStoreData('candidatePhoto', data);
              }}
            />
          )}
          renderError={renderErrorMessage}
        />
      </FieldWrapperSmall>
      <FieldWrapper>
        <Field
          registrar={registrar}
          name="candidateIdType"
          rules={[isRequired('candidateIdType is required')]}
          render={({ onChange, value }) => (
            <StyledDropdown
              options={candidateIdTypes}
              placeholder="Select your Government ID "
              selectedOption={value || candidateIdTypes[0]}
              onOptionClick={(data) => {
                onChange(data);
                updateStoreData('candidateIdType', data);
              }}
              buttonWidth="100%"
            />
          )}
          renderError={renderErrorMessage}
        />
      </FieldWrapper>
      <FieldWrapper>
        {candidateIdTypeValue === candidateIdType && (
          <Field
            registrar={registrar}
            name="candidateIdNumber"
            rules={[
              isRequired('ID number is required'),
              isNumericOnlyError(
                'This ID type cannot have alphabets & special characters'
              ),
              isIdLengthValidError(
                'Enter valid ID number',
                registrar.data.candidateIdType?.value
              )
            ]}
            render={({ onChange, value, hasError }) => (
              <StyledTextField
                placeholder="Enter ID number"
                value={value}
                onChange={(e) => {
                  onChange(e.target.value);
                  updateStoreData('candidateIdNumber', e.target.value);
                }}
                inputProps={{
                  maxLength: 20,
                  required: true
                }}
                error={hasError}
              />
            )}
            renderError={renderErrorMessage}
          />
        )}
      </FieldWrapper>
      <FormSectionSubHeading>Upload government ID</FormSectionSubHeading>
      <FieldWrapperSmall>
        <Field
          registrar={registrar}
          name="candidateId"
          rules={[
            isRequired('Upload the image'),
            isImageTypeValid('Upload an image in .png or .jpg format'),
            isImageSizeValid('Image size should not exceed 10 MB')
          ]}
          render={({ onChange, value, hasError }) => (
            <FileUploader
              value={value}
              error={hasError}
              onOptionClick={(data) => {
                onChange(data);
                updateStoreData('candidateId', data);
              }}
            />
          )}
          renderError={renderErrorMessage}
        />
      </FieldWrapperSmall>
    </SubFormContainer>
  );
};

export default UploadPhotos;
